export default __webpack_public_path__ + "static/media/thieny.1e7d8bf2.png";